import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.contentmap.addAbilityConfirmation.title',
    defaultMessage: 'HABILITY ADDED!',
  },
  subtitle: {
    id: 'simulated.contentmap.addAbilityConfirmation.subtitle',
    defaultMessage: 'New ability successfully added!',
  },
  continue: {
    id: 'simulated.contentmap.addAbilityConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
